export default __webpack_public_path__ + "static/media/6.fb6ee689.png";